(() => {
  const init = (section) => {
    if (!section || section.dataset.softwareReady === 'true') return;
    section.dataset.softwareReady = 'true';

    const search = section.querySelector('[data-software-search]');
    const clear = section.querySelector('[data-software-clear]');
    const emptyClear = section.querySelector('[data-software-empty-clear]');
    const empty = section.querySelector('[data-software-empty]');
    const count = section.querySelector('[data-software-count]');
    const filters = [...section.querySelectorAll('[data-software-filter]')];
    const items = [...section.querySelectorAll('[data-software-item]')];
    let category = 'all';

    const update = () => {
      const term = (search?.value || '').trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const matchesSearch = !term || (item.dataset.search || '').includes(term);
        const matchesCategory = category === 'all' || item.dataset.category === category;
        item.hidden = !(matchesSearch && matchesCategory);
        if (!item.hidden) visible += 1;
      });
      if (count) count.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
      if (clear) clear.hidden = !term;
    };

    const reset = () => {
      if (search) search.value = '';
      category = 'all';
      filters.forEach((button) => {
        const active = button.dataset.softwareFilter === 'all';
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      update();
    };

    search?.addEventListener('input', update);
    clear?.addEventListener('click', () => { search.value = ''; update(); search.focus(); });
    emptyClear?.addEventListener('click', reset);
    filters.forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.softwareFilter || 'all';
      filters.forEach((filter) => {
        const active = filter === button;
        filter.classList.toggle('is-active', active);
        filter.setAttribute('aria-pressed', String(active));
      });
      update();
    }));
    update();
  };

  const initAll = (root = document) => root.querySelectorAll('[data-software-section]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
